<template>
<tbody>
      <tr>
        <td class=" border-t-2 border-gray-300 px-3" rowspan="2">
            <label
                class="text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer">
                <input type="checkbox" :id="order.order"  class="form-checkbox rowCheckbox focus:outline-none focus:shadow-outline"
                        @click="getRowDetail($event,order, order.order)"> 
            </label>
        </td>
        <td  class="border-t-2 border-r-2 border-l-2 border-gray-300" >
            <!--sous table order -->
            <div class="align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard px-4 pt-2 rounded-bl-lg rounded-br-lg">
                <table class="min-w-full payment-table">
                    <thead>
                        <tr>
                            <th class="px-6 py-2 bg-gray-100 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">ID Order</th>
                            <th class="px-6 py-2 bg-gray-100 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-blue-500 tracking-wider">DETAILS</th>
                            <th class="px-6 py-2 bg-gray-100 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-blue-500 tracking-wider">Traking Number</th>
                            <th class="px-6 py-2 bg-gray-100 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-blue-500 tracking-wider">TOTAL PRICE</th>
                        </tr>
                    </thead>
                        <tbody class="bg-white">
                        <tr>
                            <td class="px-6 py-3 whitespace-no-wrap">
                                <div class="flex items-center">
                                    <div>
                                        <div class="text-sm leading-5 text-gray-800">{{$f.getIdbySplit(order.orderObjet.id)}}</div>
                                    </div>
                                </div>
                            </td>
                            <!-- <td class="px-6 py-3 whitespace-no-wrap ">
                                <div class="text-sm leading-5 text-blue-900">{{formData.seller.fullName||formData.seller.email}}</div>
                            </td>     -->
                            <td class="px-6 py-3 whitespace-no-wrap 0">
                                <div class="text-sm leading-5 text-blue-900">{{TotalProductOrder()}} Products</div>
                            </td>
                            <td class="px-6 py-3 whitespace-no-wrap">
                                <div class="text-sm leading-5 text-blue-900">{{order.trackingNumber}}</div>
                            </td>
                            <td class="px-6 py-3 whitespace-no-wrap">
                                <div class="text-sm leading-5 text-blue-900">{{order.orderObjet.totalPrice}} <span v-if="order.status=='refunded'" class="font-bold">(Order Refunded)</span></div>
                            </td>
                        </tr>
                        </tbody> 
                    </table>
                                    
            </div>        
            <!-- end sous table order -->  
        </td> 
        <td class="border-t-2 border-gray-300 border-r-2">
            <input id="confirmation" disabled  type="number" min="0" @input="changedVat"  v-model="confirmation_vat" class="py-2 border-2 border-gray-400 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
        </td>
        <td class="border-t-2 border-gray-300 border-r-2">
            <input id="shipping_fees" disabled type="number" min="0" @input="changedVat" v-model="shipping_vat" class="py-2 border-2 border-gray-400 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
        </td>
       <!-- <td :class="order.status.name=='Refunded'?'':'empty-row'" class="border-t-2 border-gray-300 border-r-2">
            <input v-if="order.status.name=='Refunded'" id="refund" type="number" min="0" @input="changedVat" v-model="shipping_refund_vat" class="py-2 border-2 border-gray-400 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
        </td>
        <td :class="shippingType=='change'?'':'empty-row'" class="border-t-2 border-gray-300">
            <input  v-if="shippingType=='change'" id="change" type="number" min="0" @input="changedVat" v-model="shipping_change_vat" class="py-2 border-2 border-gray-400 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
        </td>-->
         <td class="border-t-2 border-gray-300 border-r-2">
            <input id="shipping_fees" disabled type="number" min="0" @input="changedVat" v-model="services_fees" class="py-2 border-2 border-gray-400 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
        </td>
     </tr>
      <tr> 
        <td class="border-l-2 border-t-2 border-r-2 border-gray-300 px-3 text-right"><div class="text-base font-bold leading-5 text-blue-900">Revenue: <span class="text-green-600">{{TotalAmont().toFixed(2)}} <sup>{{warehouse.currency}}</sup></span></div></td>
        <td  class="px-6 py-3 whitespace-no-wrap border-t-2 text-right" colspan="3"><div class="text-base font-bold leading-5 text-blue-900">Total fees: <span class="text-green-600">{{totalfees.toFixed(2)}} <sup>{{warehouse.currency}}</sup></span> </div></td>
     </tr>
</tbody>        
</template>
<script>
export default {
    props: {
     item:Object, 
     warehouse:Object, 
     formData:{type: Object }, 
     confvat: Number,
     ship_vat: Number,
     ship_refund_vat: Number,
     serviceFeesRate:Number,
     ship_change_vat: Number,
     shippingSettings: Object,  // NEW PROP - pass settings.shipping
 },
 data :function () {
    return {
       order: this.item,
       totalfees:0,
       shippings:[],
       shippingType:'normal',
       shippingTypeChangCount:1,
       confirmation_vat: this.confvat,
       //shipping_vat: this.ship_vat,
       shipping_vat: 0,
       shipping_refund_vat: this.ship_refund_vat,
       shipping_change_vat: this.ship_change_vat,
       services_fees:0,
      }
    },
    watch: { 
        'item': async function(oldVal, newVal) {
           this.order=this.item;
        },
        'confvat': async function(oldVal, newVal) {
           this.confirmation_vat=this.confvat;
            this.OrderAddfees();
        },
        'ship_vat': async function(oldVal, newVal) {
           this.shipping_vat=this.ship_vat;
            this.OrderAddfees();
        },
    },
   async mounted() {
        const filters = {}; 
        this.calculateShippingFee();
        this.OrderAddfees();
   },  
   methods:{
    calculateShippingFee() {
        const orderPrice = this.order.orderObjet.totalPrice;
        
        // Check if we have price ranges
        if (this.shippingSettings && this.shippingSettings.feesRanges && this.shippingSettings.feesRanges.length > 0) {
            const sortedRanges = [...this.shippingSettings.feesRanges].sort((a, b) => a.minPrice - b.minPrice);
            
            for (const range of sortedRanges) {
                const minPrice = range.minPrice || 0;
                const maxPrice = range.maxPrice || Infinity;

                if (orderPrice >= minPrice && (maxPrice === 0 || orderPrice <= maxPrice)) {
                    this.shipping_vat = range.fees;
                    return;
                }
            }
        }
        
        // Fallback to default
        this.shipping_vat = this.ship_vat;
    },
    TotalProductOrder(){
       let totalProduct=0;
       this.order.orderObjet.details.forEach(item => {totalProduct += item.quantity;});
       return totalProduct;
    },
    changedVat(event){
         this.$emit('UpdateRowFees',this.order.order,this.confirmation_vat,this.shipping_vat,this.shipping_refund_vat,this.shipping_change_vat,this.services_fees,this.TotalAmont());
         this.OrderAddfees();
    },
    getRowDetail: function ($event,order, id) {
        this.$emit('getRowDetail',$event,order, id);
    },
    TotalAmont:function(){ 
        return parseFloat(this.order.orderObjet.totalPrice)-(this.totalfees);
    },
    OrderAddfees(){
        this.confirmation_vat = this.confirmation_vat ;
        this.order.orderObjet.confirmation_vat = this.confirmation_vat;
        this.shipping_vat= this.shipping_vat ;
        this.order.orderObjet.shipping_vat = this.shipping_vat;
        this.shipping_refund_vat=this.order.orderObjet.shipping_refund_vat=0;
        this.shipping_change_vat=this.order.orderObjet.shipping_change_vat=0;
        // if(this.order.status.name =='Refunded' ){ this.shipping_refund_vat=this.shipping_refund_vat; this.order.shipping_refund_vat = this.shipping_refund_vat;}
        // else this.shipping_refund_vat=this.order.shipping_refund_vat=0;
        // if(this.shippingType == "change"){this.shipping_change_vat= this.shipping_change_vat * this.shippingTypeChangCount; this.order.shipping_change_vat = this.shipping_change_vat * this.shippingTypeChangCount;}
        // else this.shipping_change_vat=this.order.shipping_change_vat=0;
        this.services_fees=this.order.orderObjet.services_fees = ((this.order.orderObjet.totalPrice*this.serviceFeesRate)/100).toFixed(2);
        this.totalfees= parseFloat(this.confirmation_vat)+parseFloat(this.shipping_vat)+parseFloat(this.shipping_refund_vat)+parseFloat(this.shipping_change_vat)+parseFloat(this.services_fees) ;
    },
    formattedDate(date) {
        return this.$moment(date).format('yyyy-MM-DD');
    }, 
  }  
}
</script>